import { useEffect, useState } from "react";
import "./styles.css";

type PlatformAvatarProps = {
  imageUrl?: string | null;
  name?: string;
  badgeLogo?: string;
  size?: "sm" | "md" | "lg";
  fallbackMode?: "sample" | "initial";
  className?: string;
};

const ProfileIcon = () => (
  <svg
    className="platform-avatar__profile-icon"
    viewBox="0 0 48 48"
    fill="none"
    aria-hidden="true"
  >
    <circle cx="24" cy="18" r="8" fill="currentColor" />
    <path
      d="M8 40.5c2.2-7.2 8-11 16-11s13.8 3.8 16 11"
      fill="currentColor"
    />
  </svg>
);

const PlatformAvatar = ({
  imageUrl,
  name,
  badgeLogo,
  size = "md",
  className = "",
}: PlatformAvatarProps) => {
  const [failed, setFailed] = useState(false);
  const hasProfileImage = !!imageUrl && !failed;

  useEffect(() => {
    setFailed(false);
  }, [imageUrl]);

  return (
    <div className={`platform-avatar platform-avatar--${size} ${className}`}>
      {hasProfileImage ? (
        <img
          src={imageUrl as string}
          alt={name || "Profile"}
          className="platform-avatar__image"
          onError={() => setFailed(true)}
        />
      ) : (
        <div className="platform-avatar__placeholder" aria-hidden="true">
          <ProfileIcon />
        </div>
      )}
      {badgeLogo ? (
        <span className="platform-avatar__badge-wrap">
          <img src={badgeLogo} alt="" className="platform-avatar__badge" />
        </span>
      ) : null}
    </div>
  );
};

export default PlatformAvatar;
